import { render, staticRenderFns } from "./collection-history-info.vue?vue&type=template&id=05c96348"
import script from "./collection-history-info.vue?vue&type=script&lang=ts"
export * from "./collection-history-info.vue?vue&type=script&lang=ts"
import style0 from "./collection-history-info.vue?vue&type=style&index=0&id=05c96348&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports